import React, {useContext} from 'react';
import { useHistory } from "react-router-dom";
import UserContext from '../../UserContext';

import NextIcon from '../../assets/allIcons/NextIcon';

import Footer from './Footer';

const FooterContainer = ({
    nextBtnText,
    nextBtnIcon,
    leftMargin
}) => {
    const history = useHistory();
    const { isDisabledNextBtn, setIsDisabledNextBtn } = useContext(UserContext);

    const goToPreviousPath = () => {
        history.goBack();
    }

    const goToHome = () => {
        history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk`);
    }

    const goToNext = () => {
        if (isDisabledNextBtn) {
            return;
        }
    }

    return (
        <Footer
            nextBtnText={nextBtnText || "Далее"}
            nextBtnIcon={nextBtnIcon || <NextIcon />}
            leftMargin={leftMargin}
            goToPreviousPath={goToPreviousPath}
            goToHome={goToHome}
            goToNext={goToNext}
            isDisabledNextBtn={isDisabledNextBtn}
        />
    )
}

export default FooterContainer;
